module.exports = __webpack_public_path__ + "img/1F1F5-1F1F3.005a7701.svg";